export const MIN_TAG_SEARCH_LENGTH = 2;

type TagOption = {
  id: string;
  name: string;
};

type Place = {
  name?: string;
  address?: string;
  tags?: TagOption[];
};

const normalizeSearchText = (value: unknown) => String(value || '')
  .trim()
  .toLocaleLowerCase();

export const getMapSearchResults = (
  places: Place[],
  tags: TagOption[],
  search: string,
) => {
  const query = normalizeSearchText(search);

  if (!query) {
    return { places: [], tags: [] };
  }

  const matchingPlaces = places.filter((place) => (
    normalizeSearchText(`${place.name || ''} ${place.address || ''}`).includes(query)
  ));

  if (query.length < MIN_TAG_SEARCH_LENGTH) {
    return { places: matchingPlaces, tags: [] };
  }

  const availableTagIds = new Set(
    places.flatMap((place) => (place.tags || []).map((tag) => tag.id)),
  );
  const matchingTags = tags
    .filter((tag) => (
      availableTagIds.has(tag.id)
      && normalizeSearchText(tag.name).includes(query)
    ))
    .sort((first, second) => {
      const firstName = normalizeSearchText(first.name);
      const secondName = normalizeSearchText(second.name);
      const firstRank = firstName === query ? 0 : firstName.startsWith(query) ? 1 : 2;
      const secondRank = secondName === query ? 0 : secondName.startsWith(query) ? 1 : 2;

      return firstRank - secondRank || first.name.localeCompare(second.name);
    });

  return { places: matchingPlaces, tags: matchingTags };
};
